<template lang="pug">
  b-container#journalist(fluid)
    .desktop
      #journalisttag(v-if="selectedJournalist['Nombre']"  key="tag")
        .black.pl-3.py-4.pr-3
          p.mb-1 {{ selectedJournalist["Nombre"] }}
          span.accent-text Fecha de asesinato: {{ selectedJournalist["Fecha de asesinato"] }}
        router-link.grey.pl-3.py-3.pr-3.d-flex.flex-row.align-items-center(:to="{ name: 'red', params: { name: urlName }}")
          p.mb-0 explora las características en común
          i.fas.fa-chevron-right.go-to-network.ml-4
        .propuesta-civica(v-if="selectedJournalist['Nombre'] === 'Miroslava Breach Velducea'")
          a(href="https://propuestacivica.org.mx/casos/miroslava-breach-velducea" target="_blank")
            img.img-fluid(src="/img/Colab_PC_4.png")
        .propuesta-civica(v-if="selectedJournalist['Nombre'] === 'Javier Arturo Valdez Cárdenas'")
          a(href="https://propuestacivica.org.mx/casos/javier-arturo-valdez-cardenas" target="_blank")
            img.img-fluid(src="/img/Colab_PC_4.png")
    
    #mobiletag.mobile
      #journalisttag.pt-3.pl-0(v-if="selectedJournalist['Nombre']"  key="tag")
        p.pl-3 {{ selectedJournalist["Nombre"] }}
        p.pl-3.accent-text Fecha de asesinato: {{ selectedJournalist["Fecha de asesinato"] }}
        .propuesta-civica(v-if="selectedJournalist['Nombre'] === 'Miroslava Breach Velducea'")
          a(href="https://propuestacivica.org.mx/casos/miroslava-breach-velducea" target="_blank")
            img.img-fluid(src="/img/Colab_PC_4.png")
        .propuesta-civica(v-if="selectedJournalist['Nombre'] === 'Javier Arturo Valdez Cárdenas'")
          a(href="https://propuestacivica.org.mx/casos/javier-arturo-valdez-cardenas" target="_blank")
            img.img-fluid(src="/img/Colab_PC_4.png")
    
    .mobile
      b-row.mx-auto.network-link(align-h="center")
        .col-12.pl-0
          router-link(:to="{ name: 'red', params: { name: urlName }}")
            p.underline.mb-0 Ver red del periodista 
              span.ml-2 
                i.fas.fa-chevron-right
        
    b-row.mt-3.mt-md-5(align-h="center")
      // layout for writers
      b-col#text.px-0.px-md-2.mt-2(cols="12" d-flex v-if="selectedJournalist['Perfil periodista'] === 'texto'")
        b-row.mx-auto.cards-row(align-h="center")
          .col-12.col-md-6.px-0.px-md-4.text-card.mt-3.mb-1.mx-md-4(@click="goToPublication(publication, index)" v-for="(publication, index) in journalistPublications.slice(0,2)" v-if="journalistPublications.length > 0")
            .text-box
              p {{ publication['Texto'] }}
            p.article-title.mb-1.pl-2.pl-md-0.mt-2 {{ publication['Título'] }}
            p.article-date.mb-1.pl-2.pl-md-0 {{ (new Date(publication['FDP']).toLocaleDateString('es-mx', {dateStyle: "medium"})) }}
            .d-flex
              b-col.flex.px-2.px-md-0(cols="12")
                p.tags.mr-1.mt-1.mb-0(v-for="tema in publication['Tema']") {{ tema }}

      // layout for video
      b-col#video.px-0.px-md-2.my-5(cols="12" d-flex v-if="selectedJournalist['Perfil periodista'] === 'video' && video")
        b-row.mx-auto.cards-row.align-items-end
          .col-12.col-md-8.px-0.px-md-2.video.mb-1
            iframe.col-12.px-0(width="100%" height="330px" :src="video.play" frameborder="0" v-if="video.source === 'youtube'")
            video.col-12.px-0(autoplay loop muted="true" width="100%" height="330px" v-if="video.source === 'other'")
              source.source(:src="video.play" type="video/mp4")
            
          .col-12.col-md-4(@click="goToPublication(video, 0)")
            p.article-title.mb-1.pl-2.pl-md-0.mt-2 {{ video['Título'] }}
            p.article-date.mb-1.pl-2.pl-md-0 {{ (new Date(video['FDP']).toLocaleDateString('es-mx', {dateStyle: "medium"})) }}
            p.desktop.tags.mr-1.mt-1.mb-0(v-for="tema in video['Tema']") {{ tema }}
    
    
    
    b-row.justify-content-center
      #main.col-12.col-md-9.col-lg-8
        b-row.mt-5(align-h="end")
          .col-md-3.col-12.bolder.numbers.d-flex.flex-column.align-items-start(v-if="selectedJournalist['Edad en el momento de su muerte']")
            p.numbers-text.get-ligther.mb-2 Edad de su asesinato
            p.numbers-data.age.text-left {{selectedJournalist["Edad en el momento de su muerte"]}}
          .col-md-7.col-12.bolder.numbers.d-flex.flex-column.align-items-start.ml-md-4.ml-0(v-if="selectedJournalist['Estatus más actual del caso']")
            p.numbers-text.get-ligther.mb-2 Estatus del caso
            p.numbers-data.status.text-left.mt-3 {{selectedJournalist["Estatus más actual del caso"]}}.
          //.col-md-4.col-12.bolder.numbers.justify-content-end(v-if="selectedJournalist['Fecha de asesinato']")
            p.numbers-data {{selectedJournalist["Fecha de asesinato"]}}
            p.numbers-text.get-ligther Fecha de asesinato
        b-row.row.info.mt-5(align-h="center")
          b-col(cols="12")
            p.text-justify.bold {{selectedJournalist["Nombre"]}} fue un(a) periodista&nbsp;
              span(v-if="selectedJournalist['Temas'] && selectedJournalist['Temas'].length > 0") que a lo largo de su vida cubrió temas como {{selectedJournalist["Temas"].join(", ")}}
              span .&nbsp;
              span(v-if="selectedJournalist['Últimos medios donde trabajó']") Los últimos medios donde trabajó incluyen {{selectedJournalist['Últimos medios donde trabajó']}}.&nbsp;

              span Su vida fue segada el {{selectedJournalist['Fecha de asesinato']}}&nbsp;
              span(v-if="selectedJournalist['Ciudad de asesinato']") en la ciudad de {{selectedJournalist['Ciudad de asesinato']}},&nbsp;
              span(v-if="selectedJournalist['Municipio de asesinato'] || selectedJournalist['Estado de asesinato']") en&nbsp;
              span(v-if="selectedJournalist['Municipio de asesinato']") {{selectedJournalist['Municipio de asesinato']}},&nbsp;
              span {{selectedJournalist['Estado de asesinato']}}. 

              span(v-if="selectedJournalist['Municipio de asesinato'] && (selectedJournalist['Presidente municipal'] || selectedJournalist['Partido político Presidente municipal'])") Al momento de su muerte el/la presidente municipal de {{selectedJournalist['Municipio de asesinato']}} era {{selectedJournalist['Presidente municipal']}} del {{selectedJournalist['Partido político Presidente municipal']}}.&nbsp;

              span(v-if="selectedJournalist['Estado de asesinato'] && (selectedJournalist['Gobernador'] || selectedJournalist['Partido político Gobernador'])") El gobernador de {{selectedJournalist['Estado de asesinato']}} era {{selectedJournalist['Gobernador']}} del {{selectedJournalist['Partido político Gobernador']}}.&nbsp;

              span(v-if="selectedJournalist['Grado de rezago social'] || selectedJournalist['Población de 15 años o más analfabeta'] || selectedJournalist['Tasa de homicidios por cada 100 mil habitantes']") {{selectedJournalist["Nombre"]}} ejercía el periodismo en ese municipio, donde&nbsp;
              span(v-if="selectedJournalist['Grado de rezago social']") el nivel de rezago social era {{selectedJournalist['Grado de rezago social'].toLowerCase()}}{{selectedJournalist['Población de 15 años o más analfabeta'] && selectedJournalist['Tasa de homicidios por cada 100 mil habitantes'] ? ',' : (selectedJournalist['Población de 15 años o más analfabeta'] || selectedJournalist['Tasa de homicidios por cada 100 mil habitantes']) ? ' y' : '.'}}&nbsp;
              span(v-if="selectedJournalist['Población de 15 años o más analfabeta']") el porcentaje de adultos analfabetas mayores a 15 años era {{selectedJournalist['Población de 15 años o más analfabeta']}}{{selectedJournalist['Tasa de homicidios por cada 100 mil habitantes'] ? ' y' : '.'}}&nbsp;
              span(v-if="selectedJournalist['Tasa de homicidios por cada 100 mil habitantes']") había un nivel de violencia que alcanzaba los {{selectedJournalist['Tasa de homicidios por cada 100 mil habitantes']}} homicidios por cada 100 mil habitantes.&nbsp;

              span(v-if="selectedJournalist['Carteles Presentes'] && selectedJournalist['Carteles Presentes'].length > 0") También había presencia de los siguientes grupos de crimen organizado: {{selectedJournalist["Carteles Presentes"].join(", ")}}.&nbsp;

              span(v-if='selectedJournalist["Fecha de últimas noticias"]') Hasta el {{selectedJournalist["Fecha de últimas noticias"]}}, el estatus del caso del asesinato de {{selectedJournalist["Nombre"]}} era el siguiente: {{selectedJournalist["Estatus más actual del caso"] ? selectedJournalist["Estatus más actual del caso"] : 'Sin información disponible'}}. 
            
            p(v-if="journalistPublications.length > 0") Aquí puedes conocer su trabajo.
    
        b-row.mt-5(align-h="center" v-if="journalistPublications.length > 0")
          b-col(cols="12")
            Calendar
</template>

<script>
import Calendar from "@/components/Calendar.vue";
//import * as d3 from "d3";
//import * as _ from "lodash";

export default {
  name: "Journalist",
  components: {
    Calendar,
  },
  data() {
    return {
      publications: [],
      writer: [],
      foto: [],
      sideNavOpen: false,
      video: [],
    };
  },
  computed: {
    urlName() {
      return this.selectedJournalist.Nombre
        ? this.selectedJournalist.Nombre.split(" ").join("-")
        : "";
    },
    selectedPublication: {
      get() {
        return this.$store.state.selectedPublication;
      },
      set(newValue) {
        this.$store.state.selectedPublication = newValue;
      },
    },
    selectedJournalist: {
      get() {
        return this.$store.state.selectedJournalist;
      },
      set(newValue) {
        this.$store.state.selectedJournalist = newValue;
      },
    },
    journalistPublications: {
      get() {
        return this.$store.state.journalistPublications;
      },
      set(newValue) {
        this.$store.state.journalistPublications = newValue;
      },
    },
    /*allJournalists() {
      return this.$store.state.allJournalists;
    },*/
  },
  watch: {
    selectedJournalist: async function(newValue) {
      await this.getPublicationsData();
    },
  },
  methods: {
    goToPublication(publication, index) {
      this.selectedPublication = publication;
      this.$router.push({
        path: `/publicacion/${index}/periodista/${this.urlName}`,
      });
    },
    async getPublicationsData() {
      this.video = this.journalistPublications.find(
        (p) => p["Archivo"] == "Video" && p["Amazon file"] !== ""
      );
      //console.log(this.selectedJournalist, this.video);
      /**
       * IMPORTANT
       * All video publications need to have a play property added with the youtube link that
       * allows to be embedded
       */

      if (
        this.video &&
        this.video["Amazon file"] &&
        this.video["Amazon file"].includes("youtube")
      ) {
        this.video.play = this.video["Link"].replace(/(watch\?v\=)/, "embed/");
        this.video.play = this.video.play.substr(
          0,
          this.video.play.lastIndexOf("&")
        );
        this.video.source = "youtube";
      } else if (this.video) {
        this.video.play = this.video["Amazon file"];
        this.video.source = "other";
      }
    },
    sideNavControl(action) {
      if (action == "open") {
        this.sideNavOpen = true;
        document.getElementById("journalisttag")
          ? (document.getElementById("journalisttag").style.left = "250px")
          : "";
        document.getElementById("sideNav").style.width = "250px";
        document.getElementById("main").style.marginLeft = "250px";
      } else {
        this.sideNavOpen = false;
        document.getElementById("journalisttag")
          ? (document.getElementById("journalisttag").style.left = "2rem")
          : "";
        document.getElementById("sideNav").style.width = "2rem";
        document.getElementById("main").style.marginLeft = "0";
      }
    },
    async getParams() {
      const name = this.$route.params.name.replace(/(-)/gi, " ");
      await this.$store.dispatch("getJournalistPublications", { name: name });
    },
  },
  async mounted() {
    await this.getParams();
    await this.getPublicationsData();
  },
};
</script>

<style lang="scss">
#journalist {
  #main {
    transition: 0.5s;
  }
  #journalisttag {
    position: fixed;
    top: 2rem;
    left: 0;
    width: 325px;
    transition: 0.5s;
    z-index: 2;
    .propuesta-civica {
      background-color: #f6f6f6;
    }
    .black {
      background-color: #141414;
      color: #fff;
      font-size: 15px;
      line-height: 1.2;
    }
    .grey {
      background-color: #616161;
      color: #fff;
      font-size: 15px;
      line-height: 1.2;
      cursor: pointer;
      text-decoration: none;
      &:hover {
        background-color: #920d00;
      }
    }
    .go-to-network {
      font-size: 25px;
      //width: 50px;
      //height: 50px;
      //font-weight: 400;
      color: #fff;
      //background-color: #000;
      //border-radius: 50%;
      //margin: auto;
      //display: flex;
      //justify-content: center;
      //align-items: center;
      //cursor: pointer;
      //text-decoration: none;
      //&:hover {
      //  opacity: 0.9;
      //}
    }
  }
  .sidenav {
    height: 100%;
    width: 2rem;
    position: fixed;
    z-index: 1;
    top: 0;
    left: 0;
    background-color: #fff;
    border-right: 12px solid #141414;
    overflow-x: auto;
    transition: 0.5s;
    padding-top: 60px;
    .bar {
      .title {
        color: #999999;
        //padding: 8px 8px 8px 32px;
        text-decoration: none;
        font-size: 12px;
        display: block;
        transition: 0.3s;
        /*&:hover {
          opacity: 0.6;
        }*/
      }
      .text {
        //padding: 8px 8px 8px 32px;
        text-decoration: none;
        font-size: 17px;
        display: block;
        transition: 0.3s;
        border-bottom: 1px solid #999999;
        /*&:hover {
          opacity: 0.6;
        }*/
      }
      a:hover {
        text-decoration: none;
      }
    }
    #openbtn {
      position: absolute;
      top: 5px;
      left: 5px;
      font-size: 17px;
      transition: all 0.2s ease-out;
      cursor: pointer;
      &:hover {
        opacity: 0.8;
      }
    }
    #closebtn {
      position: absolute;
      top: 0;
      right: 25px;
      font-size: 25px;
      margin-left: 50px;
      transition: all 1s ease-in-out;
      cursor: pointer;
      &:hover {
        opacity: 0.8;
      }
    }
  }
  #openbtn {
    position: absolute;
    top: 5px;
    left: 5px;
    font-size: 23px;
    transition: all 0.2s ease-out;
    cursor: pointer;
    span {
      position: fixed;
      top: 240px;
      left: 5px;
      font-size: 12px;
      transform: rotate(270deg);
      transform-origin: left top 0;
      line-height: 10px;
      //margin-top: 30px !important;
      //margin-right: 5px !important;
    }
  }
  #closebtn {
    position: absolute;
    top: 0;
    right: 25px;
    font-size: 25px;
    margin-left: 50px;
    transition: all 1s ease-in-out;
  }

  .numbers {
    display: flex;
    margin-bottom: 0;
    .numbers-data {
      line-height: 1;
      //margin-right: 5px;
      //margin-left: 10px;
      //display: flex;
      //align-items: flex-end;
      //margin-bottom: 20px;
      //text-align: right;
      &.age {
        font-size: 120px;
        color: #920d00;
        line-height: 0.8;
      }
      &.status {
        font-size: 40px;
        line-height: 0.8;
      }
    }
    .numbers-text {
      //width: 30%;
      line-height: 1;
      font-size: 14px;
      //margin-left: 5px;
      //display: flex;
      //align-items: flex-end;
      //margin-bottom: 20px;
    }
  }

  .network-link {
    margin-top: 43%;
  }

  .info {
    p {
      color: #000000ee;
      font-size: 17px;
      line-height: 19px;
      font-weight: bold;
    }
  }

  .cards-row {
    max-width: 950px;
    a:hover > p {
      text-decoration-color: #788382;
      text-decoration: underline;
    }
    .video {
      width: 100%;
    }
    .text-card {
      max-width: 380px !important;
      &:hover {
        cursor: pointer;
        .article-title {
          text-decoration: underline;
        }
      }
      .text-box {
        width: 100%;
        max-height: 318px !important;
        background-color: #788382;
        color: #fff;
        padding-top: 93%;
        position: relative;
        overflow-y: hidden;
        display: -webkit-box;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
        p {
          position: absolute;
          max-height: 100%;
          overflow-y: hidden;
          font-size: 18px;
          font-weight: 700;
          top: 1.5rem;
          left: 1.5rem;
          right: 1.5rem;
          bottom: 1.5rem;
          margin-bottom: 0;
        }
      }
    }

    .article-title {
      font-size: 22px;
      font-weight: 700;
      line-height: 1;
      color: #212529;
      &:hover {
        text-decoration: underline;
        cursor: pointer;
      }
    }
    .article-date {
      font-size: 10px;
      font-weight: 400;
      color: #212529;
    }
    .flex {
      display: flex;
      flex-wrap: wrap;
    }
    .tags {
      font-size: 11px;
      background-color: rgb(212, 212, 212);
      width: fit-content;
      padding: 0.2rem 0.8rem 0.2rem 0.8rem;
      white-space: nowrap;
      color: #212529;
      text-decoration: none !important;
    }
  }
  .underline {
    color: #000 !important;
  }
}

@media (max-width: 767.98px) {
  #mobiletag {
    #journalisttag {
      position: fixed;
      top: 2rem;
      left: 0;
      background-color: #141414;
      color: #fff;
      font-size: 15px;
      line-height: 1.2;
      width: 250px;
      transition: 0.5s;
      z-index: 300;
      padding-left: 5px;
    }
  }
  .text-box {
    padding-top: 48% !important;
  }
}
</style>
